import type { BrowserOptions } from '@sentry/react';
import { GRAPHQL_OUTCOME_METRIC } from './sentry-graphql-outcomes';

export const filterGraphqlOutcomeMetric: NonNullable<
  BrowserOptions['beforeSendMetric']
> = (metric) => {
  if (metric.name !== GRAPHQL_OUTCOME_METRIC) return metric;

  return {
    ...metric,
    attributes: {
      outcome: metric.attributes?.outcome,
      operation_type: metric.attributes?.operation_type,
      'sentry.environment': metric.attributes?.['sentry.environment'],
      'sentry.release': metric.attributes?.['sentry.release'],
    },
  };
};
